import { useState, useEffect } from "react";
import { getFeed } from "../lib/api.js";

export function useFeed(sort: string) {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    getFeed(sort)
      .then(setData)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [sort]);

  return { data, loading, error, refetch: () => getFeed(sort).then(setData) };
}
